
export class ConfigHelper {

    // getBoolConfigValue
    static async getBoolConfigValueAsync(configId: number): Promise<boolean> {
        return await this.getConfigValueAsync<boolean>(configId, ConfigDataType.Bool);
    }

    static getBoolConfigValue(configId: number, callback: (value: any | null) => void) {
        this.getConfigValue(configId, ConfigDataType.Bool, (result) => {
            callback(result);
        });
    }

    // getStringConfigValue
    static async getStringConfigValueAsync(configId: number): Promise<string> {
        return await this.getConfigValueAsync<string>(configId, ConfigDataType.String);
    }

    // getNumberConfigValue
    static async getNumberConfigValueAsync(configId: number): Promise<number> {
        return await this.getConfigValueAsync<number>(configId, ConfigDataType.Int);
    }

    // getConfigValue
    static getConfigValue(configId: number, configDataType: ConfigDataType, callback: (value: any | null) => void) {
        let data = {
            configId: configId,
            ConfigDataType: configDataType
        };
        try {
            AxessViewer.ajaxRequest('/api/ConfigurationApi/GetConfigById', data, (resp) => {

                if (resp.Value == null) {
                    callback(null);
                }

                callback(resp.Value);
            }, {
                type: 'POST',
                async: false
            });
        } catch (e) {
            console.error(e);
            callback(null);
        }
    }

    // getConfigValue
    static async getConfigValueAsync<T>(configId: number, configDataType: ConfigDataType): Promise<T> {
        let resultPromise = new Promise<T>(async (resolve, reject) => {

            let data = {
                configId: configId,
                ConfigDataType: configDataType
            };

            AxessViewer.ajaxRequest('/api/ConfigurationApi/GetConfigById', data, (resp) => {

                if (resp.Value == null) {
                    reject();
                }

                resolve(resp.Value);
            }, {
                type: 'POST'
            });
        });

        return resultPromise;
    }
}

export enum ConfigDataType {
    String = 1,
    Int = 2,
    Bool = 3,
    DateTime = 4
}

// if you want to use this helper, 
// you need to add entry with the correct id like in ConfigDefinition.cs to the enum
export enum ConfigDefinition {
    SubContingentLockAllEarlier = 188,
    RentalDataTextInput = 202,
    StoreCurrencyWebUseIsoSymbol = 7,
    RentalIsAllowedActivated = 468
}